import { Compass } from "lucide-react";

export default function ScoutBox({ children, title = "Scout recommends", testId = "scout-box" }) {
  return (
    <div data-testid={testId} className="border-l-4 border-[#E8A33D] bg-[#E7E3D9] p-5">
      <div className="flex items-center gap-2 mb-2">
        <Compass size={16} className="text-[#2D2D2D]" />
        <span className="font-head uppercase tracking-wide text-sm text-[#2D2D2D]">{title}</span>
      </div>
      <div className="text-[#1E1E1E] leading-relaxed text-[15px]">{children}</div>
    </div>
  );
}
